import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { SettingsPage } from '@apps/mtjr/vendors/app/settings/settings.page';
import { CancelOrderPage } from '@libs/mtjr/shared/orders/cancel-order.page';
import { OrderChatPage } from '@libs/mtjr/shared/orders/order-chat.page';
import { VendorDetailsPage } from '@libs/mtjr/shared/vendors/details/vendor-details.page';
import { WalletPageComponent } from '@libs/mtjr/shared/wallet/wallet.page';
import { autoLoginPartialRoutesGuard, OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs';

import { AddressPage } from '@libs/mtjr/shared/address/address.page';
import { CreateAddressPage } from '@libs/mtjr/shared/address/create_address.page';
import { EditAddressPage } from '@libs/mtjr/shared/address/edit_address.page';
import { DashboardPage } from './dashboard/dashboard.page';
import { LandingPage } from './landing/landing.page';
import { CreateOrderPage } from './orders/create-order.page';
import { OrderDetailsPage } from './orders/order-details.page';
import { OrdersPage } from './orders/orders.page';
import { ProductCreatePage } from './product/create/product-create.page';
import { ProductDetailsPage } from './product/details/product-details.page';
import { ProductEditPage } from './product/edit/product-edit.page';
import { TabsPage } from './tabs/tabs.page';
import { VendorCreateComponent } from './vendor/create/vendor-create.page';
import { VendorEditPage } from './vendor/edit/vendor-edit.page';
import { VendorsPage } from './vendor/list/vendors.page';

const redirectToMainIfLoggedIn = () => {
  const oidcService = inject(OidcSecurityService);
  const router = inject(Router);
  return oidcService
    .isAuthenticated()
    .pipe(map((isAuthenticated) => (isAuthenticated ? router.parseUrl('/main') : true)));
};

export const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'landing', component: LandingPage, canActivate: [redirectToMainIfLoggedIn] },
  {
    path: 'main',
    canActivate: [autoLoginPartialRoutesGuard],
    component: TabsPage,
    children: [
      { path: '', redirectTo: 'vendors', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardPage },
      {
        path: 'wallet',
        component: WalletPageComponent,
      },
      // Vendors stack - shared URL pattern
      { path: 'vendors', component: VendorsPage },
      { path: 'vendors/create', component: VendorCreateComponent },
      { path: 'vendors/:vendorId', component: VendorDetailsPage },
      { path: 'vendors/:vendorId/edit', component: VendorEditPage },
      { path: 'vendors/:vendorId/products/create', component: ProductCreatePage },
      { path: 'vendors/:vendorId/products/:productId', component: ProductDetailsPage },
      { path: 'vendors/:vendorId/products/:productId/edit', component: ProductEditPage },
      // Orders stack - shared URL pattern
      { path: 'orders', component: OrdersPage },
      { path: 'orders/:orderId/:subOrderId', component: OrderDetailsPage },
      { path: 'orders/:orderId/:subOrderId/chat', component: OrderChatPage },
      { path: 'orders/:orderId/:subOrderId/cancel', component: CancelOrderPage },
      {
        path: 'create-order',
        component: CreateOrderPage,
      },
      {
        path: 'settings',
        component: SettingsPage,
      },
      // Account addresses stack - shared URL pattern
      { path: 'account/addresses', component: AddressPage },
      { path: 'account/addresses/create', component: CreateAddressPage },
      { path: 'account/addresses/:addressId/edit', component: EditAddressPage },
    ],
  },

  { path: '**', redirectTo: 'landing' },
];
